// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__6-R6B","button--dark":"Button_button--dark__1woCq"};